export const handleCopyToClipboard = async (text: string) => {
  if (!navigator.clipboard) {
    console.error('Clipboard API not supported')
    return
  }

  try {
    await navigator.clipboard.writeText(text)
  } catch (err) {
    console.error('Failed to copy text to clipboard:', err)
  }
}
